import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Card, Header, Icon, Message, Button, Table } from 'semantic-ui-react';

const VisualValidateCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const resultCode = searchParams.get('resultCode');
  const bytedToken = searchParams.get('bytedToken');
  const verifyType = searchParams.get('verify_type');
  const algorithmCode = searchParams.get('algorithmBaseRespCode');
  const success = resultCode === '10000';

  return (
    <div className='dashboard-container'>
      <Card fluid>
        <Card.Content>
          <Card.Header>
            <Header as='h3'>
              <Icon name='user circle' />
              <Header.Content>真人认证结果</Header.Content>
            </Header>
          </Card.Header>
        </Card.Content>
        <Card.Content>
          {success ? (
            <Message positive>
              <Message.Header>认证成功</Message.Header>
              <p>
                活体检测已通过，请返回认证页面点击"查询认证结果"获取 Group ID。
              </p>
            </Message>
          ) : (
            <Message negative>
              <Message.Header>认证失败</Message.Header>
              <p>错误码：{resultCode || '未知'}</p>
              {algorithmCode && <p>子错误码：{algorithmCode}</p>}
            </Message>
          )}

          <Table definition>
            <Table.Body>
              <Table.Row>
                <Table.Cell width={4}>resultCode</Table.Cell>
                <Table.Cell>{resultCode || '-'}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>bytedToken</Table.Cell>
                <Table.Cell style={{ wordBreak: 'break-all' }}>
                  {bytedToken || '-'}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>verify_type</Table.Cell>
                <Table.Cell>{verifyType || '-'}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>

          <Button primary onClick={() => navigate('/visual-validate')}>
            <Icon name='arrow left' />
            返回认证页面
          </Button>
        </Card.Content>
      </Card>
    </div>
  );
};

export default VisualValidateCallback;
